export enum UserRole {

    CUSTOMER,
    DRIVER,
    AGENT,
    COMPANY
    
}